import { type DispatchContext } from "@/features/companion";
import { appEvents } from "@/shared/lib/events";

function emit(command: string, params: Record<string, unknown>): void {
  appEvents.publish({ type: "content-studio-ui-action", command, params });
}

/** Returns true if the tool was handled. */
export function dispatchContentStudioTool(toolName: string, ctx: DispatchContext): boolean {
  const { payload } = ctx;

  switch (toolName) {
    // UI navigation tools — dispatch content-studio-ui-action events (Phase 6 infrastructure)
    case "content_studio_switch_tab":
      emit("switch_tab", payload);
      return true;
    case "content_studio_filter_articles":
      emit("set_filter", payload);
      return true;
    case "content_studio_show_article": {
      const navigate = payload.navigate === true;
      emit(navigate ? "navigate_article" : "scroll_to_article", payload);
      return true;
    }
    case "content_studio_show_source":
      emit("show_source", payload);
      return true;
    case "content_studio_highlight":
      emit("highlight", payload);
      return true;
    case "content_studio_open_source_wizard":
      emit("open_source_wizard", payload);
      return true;
    case "content_studio_open_flow_wizard":
      emit("open_flow_wizard", payload);
      return true;
    case "content_studio_open_flow_detail":
      emit("open_flow_detail", payload);
      return true;
    case "content_studio_open_quick_add":
      emit("open_quick_add", payload);
      return true;
    case "content_studio_show_flow":
      emit("show_flow", payload);
      return true;
    case "content_studio_navigate_source":
      emit("navigate_source", payload);
      return true;
    case "content_studio_set_view_mode":
      emit("set_view_mode", payload);
      return true;
    case "content_studio_filter_sources":
      emit("filter_sources", payload);
      return true;

    default:
      return false;
  }
}
